import React, { PureComponent } from 'react';

class EmisorPdfPreview extends PureComponent {

  render() {
    const { link } = this.props;

    return (
      <object data={ link } type="application/pdf" width="100%" height="100%">
          <p>Si no puedes visualizar el PDF puedes ver el preview aquí <a href={ link }>to the PDF!</a></p>
      </object>
    )
  }
}

export default EmisorPdfPreview;